// src/axios.js
import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://trainingzone.it:4000', // Assicurati che questo sia l'URL corretto del tuo backend
   //  baseURL: 'http://localhost:4000', // Assicurati che questo sia l'URL corretto del tuo backend
});

export default instance;
